import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import jquery from 'jquery'
import VueLazyload from 'vue-lazyload'
import VueCookies from 'vue-cookies'
import Viewer from 'v-viewer'
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import Fragment from 'vue-fragment';
import { loadScript } from "vue-plugin-load-script";
import 'viewerjs/dist/viewer.css'
import '@livelybone/vue-datepicker/lib/css/index.css'
import './style.css'
import VueApexCharts from 'vue-apexcharts'
import {EchoConfig} from "./configs";
import { Datepicker, DateRangePicker } from '@livelybone/vue-datepicker';
import getLodash from "lodash/get";
import eachRightLodash from "lodash/eachRight";
import replaceLodash from "lodash/replace";
import vueCalendar from 'vue2-simple-calendar';

window.translate = function(string, args){
  let value = getLodash(window.i18n, string);

  eachRightLodash(args, (paramVal, paramKey) => {
    value = replaceLodash(value, `:${paramKey}`, paramVal);
  });
  return value;
}
window.$ = window.jQuery = jquery
Vue.config.productionTip = false


Vue.use(vueCalendar, {
  firstDay: 0,
  showLimit: 3,
  locale: 'ru',
  fullDayNames: false,
  fullMonthNames: false,
  componentName: 'vue-simple-calendar'
});
Vue.use(VueLazyload);
Vue.use(VueApexCharts);
Vue.use(VueCookies, { expire: '365d'});
Vue.use(Viewer);
Vue.use(Fragment.Plugin)

let axios = require('axios');
axios.defaults.headers.common = {
  'Access-Control-Allow-Origin': '*',
  'X-Requested-With': 'XMLHttpRequest',
  'X-CSRF-TOKEN' : document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
};


axios.interceptors.response.use(
    function(response)
    {
      if(response.data.redirect !== undefined && response.data.type == 'location' && window.location.pathname != response.data.redirect) window.location = response.data.redirect;
      if(response.data.redirect !== undefined && response.data.type == 'vue' && window.location.pathname != response.data.redirect) router.replace(response.data.redirect);
      return response;
    }
);
window.http = axios;
Vue.prototype.$http = axios;
Vue.prototype.$bus = new Vue();
// pusher
Vue.prototype.$pusher = Pusher;
Vue.prototype.$echo = new Echo({ ...EchoConfig });

Vue.component('datepicker', Datepicker);
Vue.component('date-range-picker', DateRangePicker);
Vue.component('apexchart', VueApexCharts)

new Vue({
  router,
  store,
  render: h => h(App),
  components:{ Datepicker, DateRangePicker},
  mounted() {
    let that = this
    window.addEventListener("load", function() {
      that.$nextTick(() => {
        const burgerExpanded = localStorage.getItem('burger_expanded');
        store.commit('setFunction', {payload: !(burgerExpanded && burgerExpanded === 'false'), name: 'burgerExpanded'})
        const theme = localStorage.getItem('theme') === 'dark' ? 'dark' : 'light'
        store.commit('setFunction', {payload: theme === 'dark', name: 'isDarkTheme'})
        document.documentElement.setAttribute('data-theme', theme);
        document.body.classList.add('app-mounted')
      });
    });
    this.$store.dispatch('getMe')
  },
}).$mount('#app');

Vue.prototype.get_options = function (items, field = null, id = null, subtitles = null, subtitle_field)
{
  if(items === undefined || items === null || items.length == 0) return [];
  let options = [];
  items.forEach(function(item)
  {
    if((field == null && id == null) || (item[field] != undefined && item[field] == id))
    {
      let title = item.title;
      if(subtitles !== null)
      {
        subtitles.forEach(function(subtitle)
        {
          if(subtitle.id == item[subtitle_field]) title = title + ' | ' + subtitle.title;
        });
      }
      options.push({'value':item.id,text:title});
    }
  });
  return options;
};

Vue.prototype.number_format = function ( number, decimals, dec_point, thousands_sep ) {	// Format a number with grouped thousands
  //
  // +   original by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
  // +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
  // +	 bugfix by: Michael White (http://crestidg.com)

  var i, j, kw, kd, km;

  // input sanitation & defaults
  if( isNaN(decimals = Math.abs(decimals)) ){
    decimals = 2;
  }
  if( dec_point == undefined ){
    dec_point = ",";
  }
  if( thousands_sep == undefined ){
    thousands_sep = ".";
  }

  i = parseInt(number = (+number || 0).toFixed(decimals)) + "";

  if( (j = i.length) > 3 ){
    j = j % 3;
  } else{
    j = 0;
  }

  km = (j ? i.substr(0, j) + thousands_sep : "");
  kw = i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands_sep);
  //kd = (decimals ? dec_point + Math.abs(number - i).toFixed(decimals).slice(2) : "");
  kd = (decimals ? dec_point + Math.abs(number - i).toFixed(decimals).replace(/-/, 0).slice(2) : "");
  return km + kw + kd;
}

Vue.prototype.pluralize = function(count, words) {
  var cases = [2, 0, 1, 1, 1, 2];
  return count + ' ' + words[ (count % 100 > 4 && count % 100 < 20) ? 2 : cases[ Math.min(count % 10, 5)] ];
};

Vue.prototype.one_property = function(array, field)
{
  let properties = [];
  array.forEach(function(object) {
    properties.push(object[field]);
  });
  return properties;
};

Vue.prototype.capitalizeFirstLetter = function(string) {
  return typeof string == 'string' ? string.charAt(0).toUpperCase() + string.slice(1) : '';
}

Vue.prototype.nl2br = function(text) {
  return text == null ? '' : text.replace(/([^>])\n/g, '$1<br/>');
};

Vue.prototype.linkWrap = function(text) {
  return text == null ? '' : text.replace(/(?<!['">])https?:\/\/\S+(?=\s|$)(?!['"<])/giu, (m) => {
    return `<a href="${m}">${m}</a>`
  });
};

Vue.prototype.pr = function(a1, a2) {
  if(!a1) return 0;
  const res = Math.floor(a1 / (a2 || 1) * 100)
  return res > 100 ? 100 : res
}

Vue.prototype.uuid = function() {
  var d = new Date().getTime();
  var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now()*1000)) || 0;//Time in microseconds since page-load or 0 if unsupported
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16;//random number between 0 and 16
    if(d > 0){//Use timestamp until depleted
      r = (d + r)%16 | 0;
      d = Math.floor(d/16);
    } else {//Use microseconds since page-load if supported
      r = (d2 + r)%16 | 0;
      d2 = Math.floor(d2/16);
    }
    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
  });
}

Vue.prototype.dateTo = function (date, time = false, sep = 'в') {
  return `${new Date(date).toLocaleDateString()}${time ? ` ${sep} ` + new Date(date).toLocaleTimeString().substr(0,5) : ''}`
}

Vue.prototype.stripTags = function (html) {
  const div = document.createElement("div");
  div.innerHTML = html;
  return div.textContent || div.innerText || ""
}

Vue.prototype.userForOptions = function(users) {
  return [{title: this.trans('labels.Not_selected'), id: null}, ...users.map(
      ({id, first_name, last_name}) => ({title: first_name + ' ' + last_name, id})
  ) || []]
}

Vue.prototype.trans = function(string, args) {
  return window.translate(string, args);
};
